import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent {
  file: File | undefined;
  emptyFile = false;
  // Se puede recibir el fichero con el emitter o con el metodo getFile.
  // El control de tamaño se hace en ApiService (toast), no aquí.
  @Output() newFileEvent = new EventEmitter();

  fileBrowseHandler(target: EventTarget | null) {
    const input = target as HTMLInputElement | null;
    this.file = input?.files?.[0] ?? undefined;
    this.checkFile();
    this.newFileEvent.emit(this.file);
  }

  checkFile() {
    this.emptyFile = !this.file;
  }

  getFile() {
    this.checkFile();
    return this.file;
  }
}
